import React, { useCallback } from 'react';

import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import messages from '../messages';
import style from '../style.module.less';

export const DeleteModal = ({ id, onDeleteAmazonConnection }) => {
  const [isDeleting, setIsDeleting] = useAsyncSafeState(false);
  const handleOnDelete = useCallback(async () => {
    setIsDeleting(true);
    await onDeleteAmazonConnection(id);
  }, [id, onDeleteAmazonConnection, setIsDeleting]);

  return (
    <Modal className={style['confirmation-modal']} size='medium'>
      <ModalHeader>
        <FormattedMessage {...messages.deleteSantosTestConnectionModalTitle} />
      </ModalHeader>
      <ModalBody className={style['confirmation-modal-body']}>
        <FormattedMessage {...messages.santosTestDeleteWarningMessage} />
      </ModalBody>
      <ModalFooter>
        <ModalFooterCancelButton />
        <Button disabled={isDeleting} onClick={handleOnDelete} theme='primary'>
          <div className={style['combine-button']}>
            <FormattedMessage {...messages.continue} />
          </div>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

DeleteModal.propTypes = {
  id: PropTypes.string.isRequired,
  onDeleteAmazonConnection: PropTypes.func.isRequired,
};
